import AutoSizeTable from 'Component/common/auto-size-table';
import UdeskPagination from 'Component/common/udesk-pagination';
import LanguageSelect from 'Component/pages/components/LanguageSelect';
import React from 'react';
import { hasFeature } from 'src/util/permit';
import Udesk from 'Udesk';
import { Button, Form, FormBuilder, Icon, Input, Modal, Popconfirm, Select, Space } from 'udesk-ui';
import UdeskLocales from 'UdeskLocales';
import { TreeMenu } from 'udesk_gm_ui';
import SelectCallTimer from '../../components/select-call-time';
import AutoGenerateTagsModal from './components/AutoGenerateTagsModal';
import TagExtractModal from './components/TagExtractModal';
import { CustomFilter } from './components/CustomFilter/index';
import IntelligentTagsRoute from './route';
import './style.scss';
import { TAG_TYPE } from './const';

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};
export default class IntelligentTagsTemplate extends IntelligentTagsRoute {
    render() {
        let { route } = this.props;
        let { columns, pageNum, pageSize, total } = this.state;
        let {
            smartTags,
            selectTagClassification,
            smartTagCategorysTree,
            smartTagCategorys,
            // isClassificationVisible,
            selectedItems,
            selectCallTimeVisible,
            redoCallIds,
            tagClassificationModalVisible,
            confirmLoading,
            formRef,
            currentTagClassification,
            loading,
            funcType,
            redoLoading,
        } = this.privates;
        const { actions, privates, locales } = this;
        const intelligentTagsLocales = locales.components.pages.intelligentTags.index;

        const isShowAutoGen = this.privates.funcType === TAG_TYPE.QUALITY_INSPECT;

        const isShowExtract = this.privates.funcType === TAG_TYPE.QUALITY_INSPECT;

        const isShowSplitGroup =
            this.privates.funcType === TAG_TYPE.USER_TAG ||
            this.privates.funcType === TAG_TYPE.PRODUCT_TAG ||
            this.privates.funcType === TAG_TYPE.SENTIMENT_TAG;

        // 将数据分成预设和普通两部分
        const presetCategories = smartTagCategorysTree.filter((item) => item.presetTag === 1);
        const normalCategories = smartTagCategorysTree.filter((item) => item.presetTag !== 1);

        return (
            // <div className="intelligent-tags-index-page">
            <div className="intelligent-tags-index-page-body">
                <If condition={hasFeature('smart:tag:view')}>
                    <div className="intelligent-tags-index-page-body-bottom">
                        <div className="intelligent-tags-index-page-body-bottom-left">
                            <div
                                style={{
                                    fontWeight: 600,
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <div>
                                    {route.name === 'keyEventsTagsIndex'
                                        ? intelligentTagsLocales.eventClassification
                                        : intelligentTagsLocales.tagClassification}
                                </div>
                                <If condition={hasFeature('smart:tag:editCategory')}>
                                    <div className="wechart-qa-tasks-check-point-classification-item">
                                        <Button
                                            // style={{ width: '100%' }}
                                            size="small"
                                            type="text"
                                            onClick={actions.newClassification.params(null)}
                                            icon={<Icon type="PlusOutlined" antdIcon={true} />}
                                            tooltip={
                                                route.name === 'keyEventsTagsIndex'
                                                    ? intelligentTagsLocales.newEventClassification
                                                    : intelligentTagsLocales.newTagClassification
                                            }
                                        ></Button>
                                    </div>
                                </If>
                            </div>
                            {/* 预设分类树 */}
                            {isShowSplitGroup && (
                                <div className="preset-categories">
                                    <div className="category-title">
                                        {/* 预设标签组 */}
                                        {
                                            UdeskLocales['current'].pages.intelligentAnalysis
                                                .intelligentTags.template.presetLabelGroup
                                        }
                                    </div>
                                    <TreeMenu
                                        treeData={presetCategories}
                                        indentUnitWidth={16}
                                        selectedKeys={
                                            selectTagClassification
                                                ? [`${selectTagClassification}`]
                                                : []
                                        }
                                        onSelect={(selectedKeys) => {
                                            actions.changeTagClassification({
                                                key: selectedKeys[0] * 1,
                                            });
                                        }}
                                    />
                                </div>
                            )}
                            {/* 普通分类树 */}
                            <div className="normal-categories">
                                {isShowSplitGroup && (
                                    <div className="category-title">
                                        {/* 自定义标签组 */}
                                        {
                                            UdeskLocales['current'].pages.intelligentAnalysis
                                                .intelligentTags.template.customLabelGroup
                                        }
                                    </div>
                                )}
                                <TreeMenu
                                    treeData={normalCategories}
                                    indentUnitWidth={16}
                                    selectedKeys={
                                        selectTagClassification
                                            ? [`${selectTagClassification}`]
                                            : []
                                    }
                                    onSelect={(selectedKeys) => {
                                        actions.changeTagClassification({
                                            key: selectedKeys[0] * 1,
                                        });
                                    }}
                                    treeNodeActionMenu={[
                                        {
                                            label: /* 编辑 */ UdeskLocales['current'].pages
                                                .intelligentAnalysis.intelligentTags.template.edit,
                                            onClick: actions.editTagClassification,
                                            disabled: (item) => {
                                                return item.llmFlag === 1;
                                            },
                                        },
                                        {
                                            label: /* 新建子分类 */ UdeskLocales['current'].pages
                                                .intelligentAnalysis.intelligentTags.template
                                                .createANewSubcategory,
                                            onClick: actions.newClassification,
                                            disabled: (item) => {
                                                return item.llmFlag === 1;
                                            },
                                        },
                                        {
                                            label: /* 删除 */ UdeskLocales['current'].pages
                                                .intelligentAnalysis.intelligentTags.template
                                                .delete,
                                            danger: true,
                                            onClick: actions.deleteTagClassification,
                                            disabled: (item) => {
                                                return item.llmFlag === 1;
                                            },
                                        },
                                    ]}
                                />
                            </div>
                        </div>
                        <div className="intelligent-tags-index-page-body-bottom-right">
                            <div className="intelligent-tags-index-page-body-search-container">
                                <Space>
                                    <LanguageSelect
                                        hasAll
                                        value={privates.lang}
                                        onChange={actions.onLangChange}
                                        allowClear
                                    />

                                    <Input.Search
                                        defaultValue={privates.tagName}
                                        value={privates.tagName}
                                        placeholder={locales.labels.searchPlaceHolder}
                                        onSearch={actions.searchItems}
                                        style={{ width: 250 }}
                                        onChange={actions.searchOnChange}
                                    />
                                </Space>

                                <Space>
                                    <If
                                        condition={
                                            hasFeature('sys:largeAi:sap:reviewTag') && isShowExtract
                                        }
                                    >
                                        <Button
                                            type="primary"
                                            onClick={actions.showTagExtractModal}
                                        >
                                            {/* 标签抽取 */}
                                            {
                                                UdeskLocales['current'].pages.intelligentAnalysis
                                                    .intelligentTags.template.labelExtraction
                                            }
                                        </Button>
                                    </If>

                                    <If
                                        condition={
                                            hasFeature('sys:largeAi:qa:smart') && isShowAutoGen
                                        }
                                    >
                                        <Button onClick={actions.showAutoGenerateModal}>
                                            {/* 自动生成标签 */}
                                            {
                                                UdeskLocales['current'].pages.intelligentAnalysis
                                                    .intelligentTags.template
                                                    .generateLabelsAutomatically
                                            }
                                        </Button>
                                    </If>
                                    <If condition={hasFeature('smart:tag:view')}>
                                        <Select
                                            value={locales.labels.batchActions}
                                            style={{ width: 120, marginRight: '10px' }}
                                            onChange={actions.selecthandleChange}
                                        >
                                            <If condition={hasFeature('smart:tag:delete')}>
                                                <Select.Option
                                                    value="delete"
                                                    style={{ padding: '0px' }}
                                                >
                                                    <Popconfirm
                                                        title={Udesk.utils.string.format(
                                                            locales.labels.deleteRecordInfo,
                                                            selectedItems.length
                                                        )}
                                                        okText={locales.labels.confirm}
                                                        cancelText={locales.labels.cancel}
                                                        onCancel={actions.deleteRecordCancel}
                                                        onConfirm={actions.deleteRecordOk}
                                                    >
                                                        <a
                                                            href=" "
                                                            onClick={actions.deletReordClick}
                                                            style={{
                                                                display: 'inline-block',
                                                                width: '100%',
                                                                padding: '5px 12px',
                                                            }}
                                                        >
                                                            {locales.labels.deleteRecord}
                                                        </a>
                                                    </Popconfirm>
                                                </Select.Option>
                                            </If>
                                            <If
                                                condition={
                                                    hasFeature('smart:tag:redo') &&
                                                    (funcType === TAG_TYPE.QUALITY_INSPECT ||
                                                        funcType === TAG_TYPE.USER_TAG ||
                                                        funcType === TAG_TYPE.PRODUCT_TAG ||
                                                        funcType === TAG_TYPE.SENTIMENT_TAG)
                                                }
                                            >
                                                <Select.Option value="redo">
                                                    {locales.labels.redo}
                                                </Select.Option>
                                            </If>
                                        </Select>
                                    </If>
                                    <If condition={hasFeature('smart:tag:add')}>
                                        <Button type="primary" onClick={actions.createItem}>
                                            {route.name === 'keyEventsTagsIndex'
                                                ? intelligentTagsLocales.createEvent
                                                : intelligentTagsLocales.createTag}
                                        </Button>
                                    </If>
                                </Space>
                            </div>
                            <AutoSizeTable
                                columns={columns}
                                dataSource={smartTags}
                                // checkable={true}
                                subtractedHeight={144}
                                rowSelection={{
                                    onSelectAll: actions.onSelectAll,
                                    selectedRowKeys: selectedItems.map((i) => i.id),
                                    onSelect: actions.onCheckChange,
                                }}
                                loading={loading}
                                pagination={false}
                            />
                            <UdeskPagination
                                current={pageNum}
                                pageSize={pageSize}
                                total={total}
                                onChange={actions.pageChanged}
                            />
                        </div>
                    </div>
                </If>
                <AutoGenerateTagsModal
                    visible={privates.autoGenerateVisible}
                    onCancel={actions.hideAutoGenerateModal}
                    onOk={actions.handleAutoGenerateSave}
                />
                <TagExtractModal
                    visible={privates.tagExtractVisible}
                    loading={privates.tagExtractLoading}
                    onCancel={actions.hideTagExtractModal}
                    onOk={actions.handleTagExtractSave}
                    smartTagCategorys={smartTagCategorysTree}
                />
                <Modal
                    visible={selectCallTimeVisible}
                    title={locales.labels.redo}
                    closeIconClass="udesk-qc-iconfont icon-qc-quxiao pull-right"
                    onCancel={actions.redo.params(false)}
                    onOk={actions.redo.params(true)}
                    headerClassName="udesk-qa-modal-default-header"
                    footerClassName="udesk-qa-modal-default-footer"
                    confirmLoading={redoLoading}
                    destroyOnClose={true}
                >
                    <SelectCallTimer
                        onDateChanged={actions.onDateChanged}
                        recordCount={redoCallIds.length}
                        callTimeText={
                            /* 记录时间 */ UdeskLocales['current'].pages.intelligentAnalysis
                                .intelligentTags.template.recordingTime
                        }
                        callTimeRemindText={
                            /* 您最多可以选择最近一年内单次不超过一个月（31天）的记录 */ UdeskLocales[
                                'current'
                            ].pages.intelligentAnalysis.intelligentTags.template
                                .youCanSelectUpToOneMonthDaysOfRecordsInTheLastYear
                        }
                    >
                        <FormBuilder
                            ref={privates.formBuilderInstance}
                            initialValues={{
                                type: privates.currentFilterDataSource,
                                filter: {
                                    judgeStrategy: 1,
                                    customJudgeLogic: '',
                                },
                            }}
                            customComponents={{ CustomFilter }}
                            fields={[
                                {
                                    type: 'Select',
                                    name: 'type',
                                    label: /* 数据类型 */ UdeskLocales['current'].pages
                                        .intelligentAnalysis.intelligentTags.template.dataType,
                                    props: {
                                        onChange: (value) => {
                                            this.privates.currentFilterDataSource = value;
                                            this.actions.update();
                                            this.actions.onFilterValueChange();
                                        },
                                        options: privates.filterDataSource.map((i) => ({
                                            label: i.name,
                                            value: i.id,
                                        })),
                                        style: {
                                            width: 200,
                                        },
                                        placeholder: locales.labels.pleaseSelect,
                                    },
                                    effect: {
                                        value: privates.filterDataSource.reduce((p, c) => {
                                            p[c.id] = [
                                                {
                                                    name: ['filter'],
                                                    output: {
                                                        judgeStrategy: 1,
                                                        customJudgeLogic: '',
                                                        conditionList: [],
                                                    },
                                                },
                                            ];
                                            return p;
                                        }, {}),
                                    },
                                },
                                {
                                    type: 'CustomFilter',
                                    name: 'filter',
                                    label: /* 筛选条件 */ UdeskLocales['current'].pages
                                        .intelligentAnalysis.intelligentTags.template
                                        .filterCriteria,
                                    rules: [{ required: true }],
                                    props: {
                                        type: privates.currentFilterDataSource,
                                        onChange: this.actions.onFilterValueChange,
                                        filterList: [
                                            'a_9',
                                            'a_35',
                                            'a_36',
                                            'a_228',
                                            'a_229',
                                            'a_505',
                                            'a_506',
                                            'a_480',
                                        ],
                                    },
                                },
                            ]}
                            footerRender={false}
                            labelCol={{ span: 4 }}
                            wrapperCol={{ span: 20 }}
                        />
                    </SelectCallTimer>
                </Modal>
                <Modal
                    title={`${
                        currentTagClassification.id ? locales.labels.edit : locales.labels.create
                    }${locales.labels.category}`}
                    onOk={actions.tagClassificationModalHandleOk}
                    confirmLoading={confirmLoading}
                    onCancel={actions.tagClassificationModalHandleCancel}
                    visible={tagClassificationModalVisible}
                    destroyOnClose
                >
                    <Form
                        {...layout}
                        name="basic"
                        initialValues={
                            currentTagClassification.id
                                ? currentTagClassification
                                : {
                                      categoryName: `${
                                          locales.components.pages.intelligentTags
                                              .defaultCategoryName
                                      }${smartTagCategorys.length + 1}`,
                                      categoryColor: '#001eff',
                                  }
                        }
                        ref={formRef}
                        onFinish={actions.onFinish}
                    >
                        <Form.Item
                            label={intelligentTagsLocales.categoryName}
                            name="categoryName"
                            rules={[
                                { required: true },
                                {
                                    pattern: new RegExp('^.{1,40}$'),
                                    message:
                                        /* 名称长度不能超过40 */ locales.pages.intelligentAnalysis
                                            .intelligentTags.template.nameLengthCannotExceed,
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label={intelligentTagsLocales.categoryColor}
                            name="categoryColor"
                        >
                            <input
                                className="udesk-qa-ui-input"
                                style={{ width: 70 }}
                                type="color"
                            />
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        );
    }
}
